<template>
    <div>
        <div id="wrapper">
            <template v-if="$route.query.headShow === '1'">
                <div class="header" :style="{'padding-top':headHeight + 'px'}">
                    <div class="header-left" @click="goBack"><img src="@/assets/vip/icon_back1.png" alt=""/></div>
                    <div class="header-main">订单详情</div>
                    <div class="header-right"></div>
                </div>
                <div class="header-pre" :style="{'padding-top':headHeight + 'px'}"></div>
            </template>
            <!-- banner区域 -->
            <div :class="['statusContent', bgName]">
                <div class="text">
                    <div class="status">{{statusText}}</div>
                </div>
            </div>
            <!-- 商品信息 -->
            <div class="goodsInfo">
                <h5 class="label">商品信息</h5>
    
                <van-skeleton title :row="4" :loading="loading">
                    <section class="top">
                        <div class="image">
                            <img v-if="$route.query.orderType == 15" class="img" src="@/assets/studyDrive/icon_lcks.png" />
                            <img v-if="$route.query.orderType == 16" class="img" src="@/assets/studyDrive/icon_yecz.png" />
                        </div>
                            <div class="right-box">
                                <div class="goods-name">{{ result.productName }}</div>
                                <div class="price">
                                    <div style="font-weight:600;color: #666666">
                                      <span>¥{{result.paymentAmount}}</span>
                                    </div>
                                    <div>x 1</div>
                                </div>
                                <div v-if="result.presentAmount" class="present-amount">赠送金额 ¥ {{result.presentAmount}}</div>
                            </div>
                    </section>
                </van-skeleton>
    
                <section class="bottom">
                    <van-skeleton title :row="6" :loading="loading">
                    <div class="row">
                        <div class="label">支付方式</div>
                        <div class="content">
                            {{selectChildData.paymentMethod[result.paymentMethod]}}
                        </div>
                    </div>
                    <div class="row">
                        <div class="label">付款金额</div>
                        <div class="content">
                          <div style="color: #FF5050">
                            <span>¥{{result.paymentAmount}}</span>
                          </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="label">订单编号</div>
                        <div class="content">
                            {{result.orderNo}}
                        </div>
                    </div>
                    <div class="row">
                        <div class="label">下单时间</div>
                        <div class="content">
                            {{result.orderTime}}
                        </div>
                    </div>
                    <div class="row" v-if="result.payTime">
                        <div class="label">支付时间</div>
                        <div class="content">
                            {{result.payTime}}
                        </div>
                    </div>
                    <div class="row" v-if="[3, 5, 7, 8, 9].includes(result.orderStatus)">
                        <div class="label">{{ finishName }}</div>
                        <div class="content">
                            {{result.finishTime}}
                        </div>
                    </div>
                    </van-skeleton>
                </section>
    
            </div>
            <!-- 底部按钮区 -->
            <footer class="footer" v-if="status === 0">
                <template v-if="status === 0">
                    <van-button class="button" type="default" :loading="payLoading" @click="handleToPay">支付</van-button>
                    <van-button class="button" type="default" :loading="cancelLoading" @click="cancel">取消</van-button>
                </template>
            </footer>
             <ctl-dialog v-model="dialogData" :loading="loading"/>
        </div>
    </div>
    </template>
    <script>
    import { Skeleton, Button, Icon, ActionSheet, Toast } from 'vant'
    import mixinStudyDrive from '@/views/public/components/mixinStudyDrive.js'
    import dialog from '@/components/dialog'
    export default {
        mixins: [mixinStudyDrive],
        components: {
            [Skeleton.name]: Skeleton,
            [Button.name]: Button,
            [Icon.name]: Icon,
            [Toast.name]: Toast,
            ctlDialog: dialog,
            [ActionSheet.name]: ActionSheet
        },
        data () {
            return {
                selectChildData: {
                    paymentMethod: {
                        1: '余额支付',
                        2: '微信',
                        3: '支付宝'
                    }
                },
                dialogData: {
                    visible: false,
                    rightBtnName: '',
                    leftBtnName: '',
                    leftBtnMethod: '',
                    rightBtnMethod: '',
                    title: '',
                    content: ''
                },
                IOS: !!(navigator.userAgent).match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
                timer: null,
                overTime: '', // 截止时间
                hour: '',
                min: '',
                headHeight: 0,
                show: false,
                payLoading: false,
                cancelLoading: false,
                refundLoading: false,
                dialogLoading: true,
                loading: true,
                bgName: 'payment',
                imgUrl: '', // 商品信息里的左侧图片url
                statusText: '',
                goodsCode: '',
                status: '',
                result: {},
                userInfo: {
                    name: '',
                    phone: '',
                    address: ''
                },
                goodsInfo: {
                    name: '',
                    price: '',
                    num: ''
                },
                id: '',
                detailList: [],
                refundInfo: {},
                finishName: ''
            }
        },
        methods: {
            // 返回
            goBack () {
                this.$router.back()
            },
            setStatus (status) {
                const { orderType } = this.$route.query
                let statusType = {
                    15: {
                        0: { text: '待付款', bg: 'payment' },
                        1: { text: '未开始', bg: 'wait' },
                        2: { text: '进行中', bg: 'wait' },
                        3: { text: '待评价', bg: 'wait' },
                        4: { text: '待学员评价', bg: 'wait' },
                        5: { text: '待教练评价', bg: 'wait' },
                        6: { text: '已完成', bg: 'completed' },
                        7: { text: '已退款', bg: 'refund', finishName: '退款时间' },
                        8: { text: '已取消', bg: 'cancelled', finishName: '取消时间' },
                        9: { text: '已爽约', bg: 'cancelled', finishName: '爽约时间' }
                    },
                    16: {
                        0: { text: '待付款', bg: 'payment' },
                        1: { text: '已完成', bg: 'completed' },
                        2: { text: '付款中', bg: 'payment' },
                        3: { text: '已取消', bg: 'cancelled', finishName: '取消时间' },
                        4: { text: '退款中', bg: 'refund' },
                        5: { text: '已退款', bg: 'refund', finishName: '退款时间' },
                    }
                }[orderType]
                this.finishName = statusType[status].finishName
                this.statusText = statusType[status].text
                this.bgName = statusType[status].bg
            },
            getData () {
                this.$api.getStudyDriveOrderDetail({ orderId: this.id }).then(res => {
                    if (res.status) {
                        res.result.orderTime = res.result.orderTime ? this.moment.formatTime(res.result.orderTime, 'YYYY-MM-DD HH:mm:ss') : ''
                        res.result.finishTime = res.result.finishTime ? this.moment.formatTime(res.result.finishTime, 'YYYY-MM-DD HH:mm:ss') : ''
                        this.result = res.result
                        this.status = res.result.orderStatus
                        this.setStatus(this.status)
                    }
                    this.loading = false
                })
            },
            // 支付回调
            payCallback (v) {
                this.$router.push({ name: 'payResult', query: { result: v, headShow: this.$route.query.headShow } })
            },
            handleToPay () {
                this.payLoading = true
                const { paymentAmount, paymentMethod } = this.result
                // 去支付
                this.studyDriveToPay({
                  id: this.id,
                  paymentAmount,
                  paymentMethod
                }).then(() => {
                  this.getData()
                })
            },
            cancel () {
                const { orderType } = this.$route.query
                if (orderType == 15) { // 约车订单
                    this.cancelBookingOrder(this.id, this.status).then(() => {
                        this.getData()
                    })
                } else {
                    this.cancelPayOrder(this.id).then(() => {
                        this.getData()
                    })
                }
            }
        },
        created () {
            this.id = this.$route.query.id
            this.goodsCode = this.$route.query.goodsCode
    
            this.getData()
    
            // 暴露支付回调方法
            this.$jsBridge.registerHandler('payCallback', this.payCallback)
        }
    }
    </script>
    <style lang="scss" scoped>
      .header{
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        display: flex;
        align-items: center;
        z-index: 9999;
        justify-content: space-between;
        height: 60px;
        background: #ffffff;
        .header-main{
          font-size:18px;
          font-weight:bold;
          color: #333333;
        }
        .header-left,.header-right{
          display: flex;
          padding: 15px 10px;
          width: 24px;
          font-size: 0;
          line-height: 1;
          img{
            width: 24px;
            height: 24px;
          }
        }
      }
      .header-pre{
        height: 60px;
      }
      #wrapper{
        background: #FAFAFA;
        height: 100%;
      }
      .payment{ // 待付款
        background: url('~@/assets/order/bg_cancelled.png') no-repeat center;
      }
      .wait{ // 待发货
        background: url('~@/assets/order/bg_to_be_shipped.png') no-repeat center;
      }
      .shipped{ // 已发货
        background: url('~@/assets/order/bg_shipped.png') no-repeat center;
      }
      .completed{ // 已完成
        background: url('~@/assets/order/bg_completed.png') no-repeat center;
      }
      .refund{ // 退款中
        background: url('~@/assets/order/bg_refund.png') no-repeat center;
      }
      .cancelled{ // 已取消
        background: url('~@/assets/order/bg_cancelled.png') no-repeat center;
      }
      .shippedInfo{
        margin-top: 7px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(51,51,51,1);
      }
      .statusContent{
        height: 100px;
        background-size: 100%;
        position: relative;
        .text{
          position: absolute;
          top: 26px;
          left: 15px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          height: 45px;
        }
        .status{
          font-size: 24px;
          font-weight: 600;
          color: rgba(51,51,51,1);
        }
        .refundInfo{
          display: flex;
          align-items: center;
          padding-top: 10px;
          font-size: 14px;
          font-weight:400;
          color: rgba(51,51,51,1);
        }
      }
      .userInfo{
        display: flex;
        background: white;
        min-height: 80px;
        margin-bottom: 10px;
        .leftIcon{
          position: relative;
          width: 60px;
          .icon{
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            margin: auto;
            width: 24px;
            height: 24px;
            background: url('~@/assets/public/icon_address_yellow@2x.png') no-repeat;
            background-size: 100%;
          }
        }
        .rightInfo{
          box-sizing: border-box;
          width: 306px;
          padding: 17px 0;
          .top{
            display: flex;
            align-items: center;
            padding-bottom: 4px;
          }
          .name{
            display: inline-block;
            padding-right: 10px;
            color: #333333;
            font-size: 18px;
            font-weight: 600;
          }
          .phone{
            font-size: 14px;
            color:rgba(51,51,51,1);
          }
          .address{
            font-size: 14px;
            color:rgba(51,51,51,1);
            word-wrap: break-word;
          }
        }
      }
      .goodsInfo{
        background: white;
        padding: 20px 15px 45px;
        .label{
          font-size: 14px;
          font-weight:400;
          color:rgba(102,102,102,1);
        }
        .top{
          display: flex;
          padding: 10px 0 6px;
          align-items: center;
          .image{
            width: 100px;
            height: 100px;
            display: flex;
            align-items: center;
            justify-content: center;
            overflow: hidden;
            line-height: 1;
            font-size: 0;
            img{
              width: 100%;
            }
          }
          .right-box{
            margin-left: 15px;
            display: flex;
            flex: 1;
            flex-direction: column;
            justify-content: center;
            .time{
              font-size:14px;
              margin-top: 5px;
              font-weight:400;
              color:rgba(51,51,51,1);
            }
            .goods-name{
              font-size: 15px;
              font-weight: 400;
              color:rgba(51,51,51,1);
              word-wrap: break-word;
            }
            .price{
              display: flex;
              justify-content: space-between;
              padding-top: 10px;
              font-size: 14px;
              color: #666666;
            }
            .present-amount {
                font-size: 12px;
                color: #666;
            }
          }
        }
      }
      .footer{
        display: flex;
        flex-direction: row-reverse;
        align-items: center;
        position: fixed;
        bottom: 0;
        width: 100%;
        border-top: 1px solid #eeeeee;
        background: white;
        box-sizing: border-box;
        padding:  12px 15px;
        .button{
          width: 90px;
          height: 24px;
          margin: 2px;
          line-height: 24px;
          font-size: 14px;
          border-radius: 3px;
          border:1px solid rgba(204,204,204,1);
        }
      }
      .dialogWrap{
        padding: 15px;
      }
      .row{
        display: flex;
        justify-content: space-between;
        padding: 10px 0;
        .label{
          font-size: 14px;
          font-weight:400;
          color:rgba(102,102,102,1);
        }
        .content{
          font-size: 14px;
          font-weight:400;
          color:rgba(51,51,51,1);
        }
      }
    
    </style>
    